var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"posSales"}},[_c('PageTitle',{attrs:{"title":_vm.$t('pos.sales.pos_sales'),"subtitle":_vm.$t('pos.sales.pos_sales_description')}}),_c('div',{staticClass:"container"},[_c('Datatable',{staticClass:"datatable",attrs:{"entity":_vm.entity,"parameters":_vm.parameters,"onRowClick":_vm.onRowClick,"maps":_vm.maps}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }